// extracted by mini-css-extract-plugin
export default {"content":"edit-request-training_content__-qjOF","content__close":"edit-request-training_content__close__-FVA3","warning":"edit-request-training_warning__zN7Vo"};